import propTypes from 'prop-types'


export default function FullScreenMessage(props) {
  return (
    <div
      className='
        flex flex-col items-center justify-center flex-1 h-full space-y-2
        text-2xl text-disabled-500
      '
    >
      {props.icon}
      {props.children}
    </div>
  )
}

FullScreenMessage.propTypes = {
  icon: propTypes.element,
}
